<div style="display: flex; gap: 20px">
  <div class="row" style="display: inline-block">
    <div class="mcd-filter-dropdown-wrapper search-wrapper">
      <div class="mcd-search-header">
        <mat-icon class="search-icon">search</mat-icon>
        <input
          type="text"
          placeholder="Type to search..."
          class="search-input-field"
          value="{{ searchKeyFromParent }}"
          (keyup.enter)="onSearch(key)"
          #key
        />
      </div>
    </div>
  </div>

  <div style="display: inline-block">
    <div class="mcd-filter-dropdown-wrapper">
      <div class="mcd-dropdown-header">
        <div
          class="dropdown-trigger-btn"
          role="button"
          tabindex="0"
          (click)="toggleStandardTypeDropdown()"
          [style]="
            isStandardTypeDropdownOpen ||
            getSelectedItemsCount('type').length > 0
              ? 'border: 1px solid #6574C4; background: #F8F9FF;'
              : 'border: 1px solid #DDE1E6;'
          "
        >
          <span class="trigger-label">Type</span>
          <span
            class="selected-count-badge"
            *ngIf="getSelectedItemsCount('type').length > 0"
          >
            {{ getDisplayText("type") }}
          </span>
          <button
            type="button"
            class="remove-button"
            *ngIf="showFilterClearButton('type')"
            (click)="removeSelected('type', $event)"
            aria-label="Clear type filter"
          >
            <img src="/assets/images/s-remove 1.svg" alt="" />
          </button>
          <span class="trigger-chevron"
            ><img
              src="/assets/images/down-arrow 1.svg"
              height="16px"
              width="16px"
              [style.transform]="
                isStandardTypeDropdownOpen ? 'rotate(180deg)' : 'rotate(0deg)'
              "
              [style.transition]="'transform 0.3s ease'"
          /></span>
        </div>
      </div>

      <div class="mcd-dropdown-content" *ngIf="isStandardTypeDropdownOpen">
        <div class="mcd-dropdown-search">
          <mat-icon class="search-icon">search</mat-icon>

          <input
            type="text"
            placeholder="Search"
            [(ngModel)]="StandardTypeSearchText"
            (input)="filterStandardTypes()"
            class="search-input"
          />
        </div>

        <div class="mcd-dropdown-options">
          <ng-container
            *ngFor="let item of filteredStandardType; let i = index"
          >
            <div class="dropdown-option-item">
              <mat-checkbox
                [checked]="setCheckedStateForCheckBoxes(3, item.id)"
                (change)="
                  addFilter($event, item.id, 3, item.name, 'StandardType')
                "
                (click)="$event.stopPropagation()"
              >
                {{
                  item.name == "Local Standards"
                    ? "Market Standards"
                    : item.name == "Global Recommendations"
                      ? "Global Approved Solutions"
                      : item.name
                }}
              </mat-checkbox>
            </div>
            <div
              class="filter-selected-divider"
              *ngIf="showFilterDivider(filteredStandardType, i, 3)"
            ></div>
          </ng-container>
          <div class="no-results" *ngIf="filteredStandardType.length === 0">
            No Standard Type found
          </div>
        </div>

        <div class="mcd-dropdown-actions">
          <button mat-button class="apply-btn" (click)="applyFilters()">
            Apply
          </button>
        </div>
      </div>
    </div>
  </div>

  <div style="display: inline-block">
    <div class="mcd-filter-dropdown-wrapper">
      <div class="mcd-dropdown-header">
        <div
          class="dropdown-trigger-btn"
          role="button"
          tabindex="0"
          (click)="toggleCategoryDropdown()"
          [style]="
            isCategoryDropdownOpen ||
            getSelectedItemsCount('category').length > 0
              ? 'border: 1px solid #6574C4; background: #F8F9FF;'
              : 'border: 1px solid #DDE1E6;'
          "
        >
          <span class="trigger-label">Category</span>
          <span
            class="selected-count-badge"
            *ngIf="getSelectedItemsCount('category').length > 0"
          >
            {{ getDisplayText("category") }}
          </span>
          <button
            type="button"
            class="remove-button"
            *ngIf="showFilterClearButton('category')"
            (click)="removeSelected('category', $event)"
            aria-label="Clear category filter"
          >
            <img src="/assets/images/s-remove 1.svg" alt="" />
          </button>
          <span class="trigger-chevron"
            ><img
              src="/assets/images/down-arrow 1.svg"
              height="16px"
              width="16px"
              [style.transform]="
                isCategoryDropdownOpen ? 'rotate(180deg)' : 'rotate(0deg)'
              "
              [style.transition]="'transform 0.3s ease'"
          /></span>
        </div>
      </div>

      <div class="mcd-dropdown-content" *ngIf="isCategoryDropdownOpen">
        <div class="mcd-dropdown-search">
          <mat-icon class="search-icon">search</mat-icon>

          <input
            type="text"
            placeholder="Search"
            [(ngModel)]="categorySearchText"
            (input)="filterCategories()"
            class="search-input"
          />
        </div>

        <div class="mcd-dropdown-options">
          <ng-container *ngFor="let item of filteredCategories; let i = index">
            <div class="dropdown-option-item">
              <mat-checkbox
                [checked]="setCheckedStateForCheckBoxes(2, item.id)"
                (change)="addFilter($event, item.id, 2, item.name, 'category')"
                (click)="$event.stopPropagation()"
              >
                {{ item.name }}
              </mat-checkbox>
            </div>
            <div
              class="filter-selected-divider"
              *ngIf="showFilterDivider(filteredCategories, i, 2)"
            ></div>
          </ng-container>
          <div class="no-results" *ngIf="filteredCategories.length === 0">
            No categories found
          </div>
        </div>

        <div class="mcd-dropdown-actions">
          <button mat-button class="apply-btn" (click)="applyFilters()">
            Apply
          </button>
        </div>
      </div>
    </div>
  </div>

  <div style="display: inline-block">
    <div class="mcd-filter-dropdown-wrapper">
      <div class="mcd-dropdown-header">
        <div
          class="dropdown-trigger-btn"
          role="button"
          tabindex="0"
          (click)="toggleLocationDropdown()"
          [style]="
            isLocationDropdownOpen ||
            getSelectedItemsCount('location').length > 0
              ? 'border: 1px solid #6574C4; background: #F8F9FF;'
              : 'border: 1px solid #DDE1E6;'
          "
        >
          <span class="trigger-label">Location</span>
          <span
            class="selected-count-badge"
            *ngIf="getSelectedItemsCount('location').length > 0"
          >
            {{ getDisplayText("location") }}
          </span>
          <button
            type="button"
            class="remove-button"
            *ngIf="showFilterClearButton('location')"
            (click)="removeSelected('location', $event)"
            aria-label="Clear location filter"
          >
            <img src="/assets/images/s-remove 1.svg" alt="" />
          </button>
          <span class="trigger-chevron"
            ><img
              src="/assets/images/down-arrow 1.svg"
              height="16px"
              width="16px"
              [style.transform]="
                isLocationDropdownOpen ? 'rotate(180deg)' : 'rotate(0deg)'
              "
              [style.transition]="'transform 0.3s ease'"
          /></span>
        </div>
      </div>

      <div class="mcd-dropdown-content" *ngIf="isLocationDropdownOpen">
        <div class="mcd-dropdown-search">
          <mat-icon class="search-icon">search</mat-icon>
          <input
            type="text"
            placeholder="Search"
            [(ngModel)]="locationSearchText"
            (input)="filterLocations()"
            class="search-input"
          />
        </div>

        <div class="mcd-dropdown-options">
          <ng-container *ngFor="let item of filteredLocations; let i = index">
            <div class="dropdown-option-item">
              <mat-checkbox
                [checked]="setCheckedStateForCheckBoxes(1, item.id)"
                (change)="addFilter($event, item.id, 1, item.name, 'location')"
                (click)="$event.stopPropagation()"
              >
                {{ item.name }}
              </mat-checkbox>
            </div>
            <div
              class="filter-selected-divider"
              *ngIf="showFilterDivider(filteredLocations, i, 1)"
            ></div>
          </ng-container>
          <div class="no-results" *ngIf="filteredLocations.length === 0">
            No locations found
          </div>
        </div>

        <div class="mcd-dropdown-actions">
          <button mat-button class="apply-btn" (click)="applyFilters()">
            Apply
          </button>
        </div>
      </div>
    </div>
  </div>

  <div style="flex: 1"></div>
  <div>
    <button class="extract-button" (click)="openExportModal()">
      <img src="/assets/images/export 1.svg" style="margin-right: 5px" />Export
    </button>
  </div>

  <!-- <div class="col-md-4">
    <div class="mcd-filter-tag-wrapper">
      <div class="mcd-tag-title">Standard Type</div>
      <mat-checkbox
        *ngFor="let item of standardTypes"
        [checked]="setCheckedStateForCheckBoxes(3, item.id)"
        (change)="addFilter($event, item.id, 3,item.name, 'StandardType')"
        >{{
          item.name == "Local Standards"
            ? "Market Standards"
            : item.name == "Global Recommendations"
            ? "Global Approved Solutions"
            : item.name
        }}</mat-checkbox
      >
    </div>
  </div> -->

  <!-- <div class="col-md-4">
    <div class="mcd-filter-tag-wrapper">
      <div class="mcd-tag-title">Category</div>
      <mat-checkbox
        *ngFor="let item of categories"
        [checked]="setCheckedStateForCheckBoxes(2, item.id)"
        (change)="addFilter($event, item.id, 2,item.name, 'Category')"
        >{{ item.name }}</mat-checkbox
      >
    </div>
  </div> -->
  <!-- <div class="col-md-4 last-filter-wrapper">
    <div class="mcd-filter-tag-wrapper">
      <div class="mcd-tag-title">Location</div>
      <mat-checkbox
        *ngFor="let item of locationTypes"
        [checked]="setCheckedStateForCheckBoxes(1, item.id)"
        (change)="addFilter($event, item.id, 1,item.name, 'Location')"
        >{{ item.name }}</mat-checkbox
      >
    </div>
  </div> -->
</div>

<!-- ++++++++++++++=======================Export modal+++++++++++++++++++++++++++++++++++++ -->

<!-- Trigger Button -->
<!-- <button class="export-modal-trigger-btn" (click)="openExportModal()">
    <img src="/assets/images/export 1.svg" style="margin-right: 5px" />
    Export
</button> -->

<!-- Export Modal -->
<div
  *ngIf="isExportModalOpen"
  class="modal-overlay"
  (click)="closeExportModal()"
>
  <div class="modal-content" (click)="$event.stopPropagation()">
    <!-- Modal Header -->
    <div class="modal-header">
      <h2>Export Standards</h2>
      <button class="close-btn" (click)="closeExportModal()">×</button>
    </div>

    <!-- Modal Body -->
    <div class="modal-body">
      <!-- Standard Type Dropdown -->
      <div class="filter-group">
        <label class="filter-label">Standard Type</label>
        <div
          class="export-modal-filter-dropdown-wrapper"
          [style.z-index]="isExportStandardTypeDropdownOpen ? 30 : 1"
        >
          <div
            class="export-modal-dropdown-header"
            (click)="toggleExportDropdown('standardType')"
          >
            <button
             
              class="export-modal-dropdown-trigger-btn buttonArrow"
              [style]="
                isExportStandardTypeDropdownOpen ||
                getExportSelectedItemsCount('type').length > 0
                  ? 'border: 1px solid #6574C4; background: #F8F9FF;'
                  : 'border: 1px solid #DDE1E6;'
              "
              style="display: flex; justify-content: space-between; width: 100%"
            >
              <span
                class="export-modal-selected-count-badge"
                *ngIf="getExportSelectedItemsCount('type').length > 0"
              >
                {{ getExportDisplayText("type") }}
              </span>

              <span *ngIf="getExportSelectedItemsCount('type').length == 0">
                All
              </span>
              <span>
                <img
                  src="/assets/images/down-arrow 1.svg"
                  height="16px"
                  width="16px"
                  [style.transform]="
                    isExportStandardTypeDropdownOpen
                      ? 'rotate(180deg)'
                      : 'rotate(0deg)'
                  "
                  [style.transition]="'transform 0.3s ease'"
                />
              </span>
            </button>
          </div>

          <div
            class="export-modal-dropdown-content"
            *ngIf="isExportStandardTypeDropdownOpen"
          >
            <!-- <div class="export-modal-dropdown-search">
              <mat-icon class="export-modal-search-icon">search</mat-icon>
              <input
                type="text"
                placeholder="Search"
                [(ngModel)]="StandardTypeSearchText"
                (input)="filterStandardTypes()"
                class="export-modal-search-input"
              />
            </div> -->

            <div class="export-modal-dropdown-options">
              <ng-container
                *ngFor="let item of filteredStandardType; let i = index"
              >
                <div class="export-modal-dropdown-option-item">
                  <mat-checkbox
                    [checked]="setExportCheckedStateForCheckBoxes(3, item.id)"
                    (change)="
                      addExportFilter(
                        $event,
                        item.id,
                        3,
                        item.name,
                        'StandardType'
                      )
                    "
                    (click)="$event.stopPropagation()"
                  >
                    {{
                      item.name == "Local Standards"
                        ? "Market Standards"
                        : item.name == "Global Recommendations"
                          ? "Global Approved Solutions"
                          : item.name
                    }}
                  </mat-checkbox>
                </div>
                <div
                  class="filter-selected-divider"
                  *ngIf="showExportFilterDivider(filteredStandardType, i, 3)"
                ></div>
              </ng-container>
              <!-- <div
                class="export-modal-no-results"
                *ngIf="filteredStandardType.length === 0"
              >
                No Standard Type found
              </div> -->
            </div>

            <!-- <div class="export-modal-dropdown-actions">
              <button
                mat-button
                class="export-modal-apply-btn"
                (click)="applyFilters()"
              >
                Apply
              </button>
            </div> -->
          </div>
        </div>
      </div>

      <!-- Category Dropdown -->
      <div class="filter-group">
        <label class="filter-label">Category</label>
        <div
          class="export-modal-filter-dropdown-wrapper"
          [style.z-index]="isExportCategoryDropdownOpen ? 30 : 1"
        >
          <div
            class="export-modal-dropdown-header"
            (click)="toggleExportDropdown('category')"
          >
            <button
              
              class="export-modal-dropdown-trigger-btn buttonArrow"
              [style]="
                isExportCategoryDropdownOpen ||
                getExportSelectedItemsCount('category').length > 0
                  ? 'border: 1px solid #6574C4; background: #F8F9FF;'
                  : 'border: 1px solid #DDE1E6;'
              "
              style="display: flex; justify-content: space-between; width: 100%"
            >
              <span
                class="export-modal-selected-count-badge"
                *ngIf="getExportSelectedItemsCount('category').length > 0"
              >
                {{ getExportDisplayText("category") }}
              </span>
              <span *ngIf="getExportSelectedItemsCount('category').length == 0">
                All
              </span>
              <span>
                <img
                  src="/assets/images/down-arrow 1.svg"
                  height="16px"
                  width="16px"
                  [style.transform]="
                    isExportCategoryDropdownOpen
                      ? 'rotate(180deg)'
                      : 'rotate(0deg)'
                  "
                  [style.transition]="'transform 0.3s ease'"
                />
              </span>
            </button>
          </div>

          <div
            class="export-modal-dropdown-content"
            *ngIf="isExportCategoryDropdownOpen"
          >
            <!-- <div class="export-modal-dropdown-search">
              <mat-icon class="export-modal-search-icon">search</mat-icon>
              <input
                type="text"
                placeholder="Search"
                [(ngModel)]="categorySearchText"
                (input)="filterCategories()"
                class="export-modal-search-input"
              />
            </div> -->

            <div class="export-modal-dropdown-options">
              <ng-container
                *ngFor="let item of filteredCategories; let i = index"
              >
                <div class="export-modal-dropdown-option-item">
                  <mat-checkbox
                    [checked]="setExportCheckedStateForCheckBoxes(2, item.id)"
                    (change)="
                      addExportFilter($event, item.id, 2, item.name, 'category')
                    "
                    (click)="$event.stopPropagation()"
                  >
                    {{ item.name }}
                  </mat-checkbox>
                </div>
                <div
                  class="filter-selected-divider"
                  *ngIf="showExportFilterDivider(filteredCategories, i, 2)"
                ></div>
              </ng-container>
              <!-- <div
                class="export-modal-no-results"
                *ngIf="filteredCategories.length === 0"
              >
                No categories found
              </div> -->
            </div>

            <!-- <div class="export-modal-dropdown-actions">
              <button
                mat-button
                class="export-modal-apply-btn"
                (click)="applyFilters()"
              >
                Apply
              </button>
            </div> -->
          </div>
        </div>
      </div>

      <!-- Location Dropdown -->
      <div class="filter-group">
        <label class="filter-label">Location</label>
        <div
          class="export-modal-filter-dropdown-wrapper"
          [style.z-index]="isExportLocationDropdownOpen ? 30 : 1"
        >
          <div
            class="export-modal-dropdown-header"
            (click)="toggleExportDropdown('location')"
          >
            <button
             
              class="export-modal-dropdown-trigger-btn buttonArrow"
              [style]="
                isExportLocationDropdownOpen ||
                getExportSelectedItemsCount('location').length > 0
                  ? 'border: 1px solid #6574C4; background: #F8F9FF;'
                  : 'border: 1px solid #DDE1E6;'
              "
              style="display: flex; justify-content: space-between; width: 100%"
            >
              <span
                class="export-modal-selected-count-badge"
                *ngIf="getExportSelectedItemsCount('location').length > 0"
              >
                {{ getExportDisplayText("location") }}
              </span>
              <span *ngIf="getExportSelectedItemsCount('location').length == 0">
                All
              </span>
              <span>
                <img
                  src="/assets/images/down-arrow 1.svg"
                  height="16px"
                  width="16px"
                  [style.transform]="
                    isExportLocationDropdownOpen
                      ? 'rotate(180deg)'
                      : 'rotate(0deg)'
                  "
                  [style.transition]="'transform 0.3s ease'"
                />
              </span>
            </button>
          </div>

          <div
            class="export-modal-dropdown-content"
            *ngIf="isExportLocationDropdownOpen"
          >
            <!-- <div class="export-modal-dropdown-search">
              <mat-icon class="export-modal-search-icon">search</mat-icon>
              <input
                type="text"
                placeholder="Search"
                [(ngModel)]="locationSearchText"
                (input)="filterLocations()"
                class="export-modal-search-input"
              />
            </div> -->

            <div class="export-modal-dropdown-options">
              <ng-container
                *ngFor="let item of filteredLocations; let i = index"
              >
                <div class="export-modal-dropdown-option-item">
                  <mat-checkbox
                    [checked]="setExportCheckedStateForCheckBoxes(1, item.id)"
                    (change)="
                      addExportFilter($event, item.id, 1, item.name, 'location')
                    "
                    (click)="$event.stopPropagation()"
                  >
                    {{ item.name }}
                  </mat-checkbox>
                </div>
                <div
                  class="filter-selected-divider"
                  *ngIf="showExportFilterDivider(filteredLocations, i, 1)"
                ></div>
              </ng-container>
              <!-- <div
                class="export-modal-no-results"
                *ngIf="filteredLocations.length === 0"
              >
                No locations found
              </div> -->
            </div>

            <!-- <div class="export-modal-dropdown-actions">
              <button
                mat-button
                class="export-modal-apply-btn"
                (click)="applyFilters()"
              >
                Apply
              </button>
            </div> -->
          </div>
        </div>
      </div>
    </div>

    <!-- Modal Footer -->
    <div class="export-modal-footer">
      <button class="export-modal-cancel-btn" (click)="closeExportModal()">
        Cancel
      </button>
      <button class="export-modal-export-btn" (click)="applyExportFilters()">
        <img
          src="/assets/images/export-black.svg"
          style="
            margin-bottom: 2px;
            margin-right: 4px;
            height: 12px;
            width: 12px;
          "
        />Export
      </button>
    </div>
  </div>
</div>
